import { apiRequest } from "./client";

export interface ApiDistributorTourShort {
    id: string;
    name_ru: string;
    slug: string | null;
}

export interface ApiDistributor {
    id: string;
    name: string;
    email: string | null;
    contact_phone: string | null;
    api_key: string;
    is_active: boolean;
    note: string | null;
    created_at: string;
    last_used_at: string | null;
    allowed_tours?: ApiDistributorTourShort[];
}

export interface CreateApiDistributorPayload {
    name: string;
    email?: string | null;
    contact_phone?: string | null;
    note?: string | null;
}

export interface UpdateApiDistributorPayload {
    name?: string;
    email?: string | null;
    contact_phone?: string | null;
    note?: string | null;
    is_active?: boolean;
}

export interface RotateKeyResponse {
    id: string;
    api_key: string;
}

const BASE = "/admin/api-distributors";

export const listApiDistributorsRequest = async (
    params: { is_active?: boolean } = {},
): Promise<ApiDistributor[]> => {
    const query =
        typeof params.is_active === "boolean"
            ? `?is_active=${params.is_active}`
            : "";

    return apiRequest<ApiDistributor[]>(`${BASE}${query}`, {
        method: "GET",
        auth: true,
    });
};

export const getApiDistributorRequest = async (
    id: string,
): Promise<ApiDistributor> => {
    return apiRequest<ApiDistributor>(`${BASE}/${id}`, {
        method: "GET",
        auth: true,
    });
};

export const createApiDistributorRequest = async (
    payload: CreateApiDistributorPayload,
): Promise<ApiDistributor> => {
    return apiRequest<ApiDistributor>(BASE, {
        method: "POST",
        auth: true,
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
    });
};

export const updateApiDistributorRequest = async (
    id: string,
    payload: UpdateApiDistributorPayload,
): Promise<ApiDistributor> => {
    return apiRequest<ApiDistributor>(`${BASE}/${id}`, {
        method: "PATCH",
        auth: true,
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
    });
};

export const rotateApiDistributorKeyRequest = async (
    id: string,
): Promise<RotateKeyResponse> => {
    return apiRequest<RotateKeyResponse>(`${BASE}/${id}/rotate-key`, {
        method: "POST",
        auth: true,
    });
};

export const deleteApiDistributorRequest = async (id: string): Promise<void> => {
    await apiRequest<void>(`${BASE}/${id}`, {
        method: "DELETE",
        auth: true,
    });
};

// -------- allowed tours --------

export const getAllowedToursRequest = async (
    distributorId: string,
): Promise<ApiDistributorTourShort[]> => {
    return apiRequest<ApiDistributorTourShort[]>(
        `${BASE}/${distributorId}/allowed-tours`,
        {
            method: "GET",
            auth: true,
        },
    );
};

export const setAllowedToursRequest = async (
    distributorId: string,
    tourIds: string[],
): Promise<ApiDistributor> => {
    return apiRequest<ApiDistributor>(
        `${BASE}/${distributorId}/allowed-tours`,
        {
            method: "PUT",
            auth: true,
            body: JSON.stringify({ tour_ids: tourIds }),
            headers: { "Content-Type": "application/json" },
        },
    );
};

export const addAllowedTourRequest = async (
    distributorId: string,
    tourId: string,
): Promise<ApiDistributor> => {
    return apiRequest<ApiDistributor>(
        `${BASE}/${distributorId}/allowed-tours/${tourId}`,
        {
            method: "POST",
            auth: true,
        },
    );
};

export const removeAllowedTourRequest = async (
    distributorId: string,
    tourId: string,
): Promise<ApiDistributor> => {
    return apiRequest<ApiDistributor>(
        `${BASE}/${distributorId}/allowed-tours/${tourId}`,
        {
            method: "DELETE",
            auth: true,
        },
    );
};
